import { importAll, transformImages } from "utils";

import Gallery from "components/Media/Gallery";
import { Link } from "react-router-dom";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import backgroundImage from "./gallery/promo_00.jpg";
import { routes } from "config";
import theDailyProphetV2DarkMarkSparksPanic from "assets/replicas/harry-potter/hp-daily-prophets/hp-daily-prophet-hp7-dark-mark-sparks-panic";
import theDailyProphetV2DarkMarkSparksPanicV2 from "assets/replicas/harry-potter/hp-daily-prophets/hp-daily-prophet-hp7-dark-mark-sparks-panic/v2";

let gallery = [];
try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/),
  );
} catch (e) {
  console.warn(e);
}

const background = {
  src: backgroundImage,
  opacity: 0.1,
};

const Page = () => {
  const galleryImages = transformImages(gallery);

  return (
    <ReplicaContent>
      <ReplicaParagraph>
        This is a Grade-B replica of{" "}
        <Link
          to={`/${routes.replicaDetailVersion.slug.replace(":id", theDailyProphetV2DarkMarkSparksPanic.id).replace(":version", `v${theDailyProphetV2DarkMarkSparksPanicV2.version}`)}`}
          target="_blank"
        >
          The Daily Prophet v2 - Dark Mark Sparks
        </Link>{" "}
        Magic. The replica is otherwise identical to the final version, with
        only a few minor blemishes. The front page has two small tears that have
        been repaired from the reverse side using a bit of tape, and page 5 is
        missing a small piece of its bottom-right corner. Apart from these
        imperfections, the newspaper is in excellent condition. It is graded as
        "B" only because the damage was unintentional; in practice, neither flaw
        looks particularly out of place on a replica that is meant to appear
        naturally aged and handled.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages}
        imagesPerRow={5}
        aspectRatio={1}
        imageMaxHeight="240px"
        imageOptions={[
          { index: 1, aspectRatio: 1.2 },
          { index: 2, aspectRatio: 2 },
        ]}
      />
      <ReplicaSpacer />
    </ReplicaContent>
  );
};

export default Page;
export { background };
